// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"5614bc8e","550":"d63fbb99"}[chunkId] + ".chunk.css";
};